
















import Vue, { PropType } from 'vue'
import mediaMixin from '@/mixins/media-mixin'
import { MediaFolder } from '@/types/Media.interface'
import Person from '@/types/Person.interface'
import LoadingMask from '@/components/LoadingMask.vue'
export default Vue.extend({
    mixins: [mediaMixin],
    components: { LoadingMask },
    props: {
        folder: {
            type: String as PropType<MediaFolder>,
            default: null
        },
        person: {
            type: Object as PropType<Person>,
            default: null
        }
    },
    data: () => ({
        loading: false
    }),
    methods: {
        async onFilesChanged(event: Event) {
            //  Start the loader
            this.loading = true

            //  Cast the target to an HTMLInputElement
            const target = event.target as HTMLInputElement

            //  Upload the files
            await this.filesChange(target.files)

            //  Stop the loader
            this.loading = false
        },
        async onDropHandler(event: DragEvent): Promise<void> {
            //  Start the loader
            this.loading = true

            //  Upload the files
            await this.onDrop(event)

            //  Stop the loader
            this.loading = false
        },
        reset(): void {
            this.$refs.mediaUploadForm.reset()
        }
    }
})
